<template>
  <div id="map-controls-sidebar-vehicle-heavy-equipment">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activeVehicleSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="aisea-text-18-700-white">管理車両</span>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_VEHICLE_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY"/>
        <div class="induction-area" v-if="vehicleList.length === 0 && heavyEquipmentList.length === 0">
          <div class="induction-comment">
            GPS情報を使用して管理車両の位置を特定します<br />
            詳しくは担当営業まで<br />
          </div>
        </div>
        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-2 pb-10"
          :settings="settings"
          :key="$vs.rtl"
        >
          <vs-collapse>
            <vs-collapse-item >
              <div class="aisea-text-16-400-white" slot="header" id="filters-vehicle-collapse-item-header">
                車両
              </div>
              <vehicle :vehicleList="vehicleList" ></vehicle>
            </vs-collapse-item>

            <vs-collapse-item >
              <div class="aisea-text-16-400-white" slot="header" id="filters-heavy-equipment-collapse-item-header">
                重機
              </div>
              <vehicle :vehicleList="heavyEquipmentList" ></vehicle>
            </vs-collapse-item>

          </vs-collapse>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import Vue from 'vue';
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { db } from "@/firebase/firebaseConfig.js";

import Vehicle from "./items/Vehicle";

import {createNamespacedHelpers} from "vuex";

// Mixins
import {ColorMixin, VehicleMixin} from "@/mixins";


const {
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap
} = createNamespacedHelpers("liveMap");


export default {
  mixins: [ColorMixin, VehicleMixin],
  components: {
    VuePerfectScrollbar,
    Vehicle,
  },
  data() {
    return {
      init: false,
      active: false,
      type: "margin",
      settings: {
        maxScrollbarLength: 50,
        wheelSpeed: 0.6
      },
      activeVehicleCollapse: false,
      activeHeavyEquipmentCollapse: false,
      initiallyOpened: true,
      unsubscribes: [],
      firestoreVehicleMap: {},
    };
  },
  watch: {
    async activeVehicleSidebar(val) {
      if (val) {
        await this.subscribeVehicles();
        if (!this.init) {
          setTimeout(() => {
            this.onClickCollapse()
          }, 500);
          this.init = true
        }
      } else {
        if (this.unsubscribes.length !== 0) {
          this.unsubscribes.forEach(unsubscribe => unsubscribe());
          this.unsubscribes = [];
        }
      }
    }
  },
  computed: {
    ...mapStateOfLiveMap({
      activeVehicleSidebar: state => state.activeVehicleSidebar
    }),
    footerTypeLocal: {
      get() {
        return this.footerType;
      },
      set(val) {
        this.$emit("updateFooter", val);
      }
    },
    hideScrollToTopLocal: {
      get() {
        return this.hideScrollToTop;
      },
      set(val) {
        this.$emit("toggleHideScrollToTop", val);
      }
    },
    rtl: {
      get() {
        return this.$vs.rtl;
      },
      set(val) {
        this.$vs.rtl = val;
      }
    },
    themeMode: {
      get() {
        return this.$store.state.theme;
      },
      set(val) {
        this.$store.dispatch("updateTheme", val);
      }
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    },
    vehicleList() {
      return Object.values(this.firestoreVehicleMap).filter(x => x.type === this.VEHICLE_TYPE.VEHICLE);
    },
    heavyEquipmentList() {
      return Object.values(this.firestoreVehicleMap).filter(x => x.type === this.VEHICLE_TYPE.HEAVY_EQUIPMENT);
    },
  },
  methods: {
    ...mapMutationsOfLiveMap([
      "SET_ACTIVE_VEHICLE_SIDEBAR",
    ]),
    updatePrimaryColor(color) {
      this.primaryColor = color;
      this.$vs.theme({primary: color});
    },
    onClickCollapse() {
      document.getElementById('filters-vehicle-collapse-item-header').click()
      document.getElementById('filters-heavy-equipment-collapse-item-header').click()
    },

    async subscribeVehicles() {

      const enterpriseId = this.$store.state.auth.user.id;

      let unsubscribe = await db
        .collection(`vehicles/e:${enterpriseId}/trackimo`)
        .where("type", "in", [ this.VEHICLE_TYPE.VEHICLE, this.VEHICLE_TYPE.HEAVY_EQUIPMENT ])
        .onSnapshot(snapshot => {
          // FireStoreからデータ取得
          snapshot.docChanges().forEach(diff => {
            Vue.set(this.firestoreVehicleMap, diff.doc.id, diff.doc.data());
          });
        });
      this.unsubscribes.push(unsubscribe);
    },

  },
  beforeDestroy() {
    if (this.unsubscribes.length !== 0) {
      this.unsubscribes.forEach(unsubscribe => unsubscribe());
      this.unsubscribes = [];
    }
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-vehicle-heavy-equipment {
  .vs-collapse-item--header {
    padding: 0;
  }

  .vs-collapse {
    padding: 0 20px 20px;
  }

  .vs-collapse-item--content {
    border-radius: 5px;
  }

  .header-label {
    color: $aisea-white;
  }

  .icon-header {
    color: $aisea-white;
  }

  .con-content--item {
    padding: 0;
    background-color: $aisea-blue-gray;
  }

  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1.0;
  }

  .vs-collapse-item--icon-header {
    right: -15px;

    .vs-icon {
      font-size: 2rem;
    }
  }

  .vs-collapse-item {
    border-bottom: 0;
  }

  .induction-area {
    .induction-comment {
      margin: 1.0rem 1.5rem 2.0rem 1.5rem;
      padding: 0.4rem 1.0rem;
      background-color: $aisea-blue-gray;
      color: $aisea-light-white;
    }
  }

}
</style>
